import { frontendURL } from '../../../../helper/URLHelper';

// Rotas que sao "navegar pelos contatos" e portanto mantem o item "Todos os Contatos" aceso.
// A lista precisa ser explicita: o casamento por prefixo do router-link foi desligado para itens
// com regra propria (ver SidebarSecondaryItem), justamente porque /contacts/wallet acendia o
// /contacts junto.
const ALL_CONTACTS_ROUTES = [
  'contacts_dashboard',
  'contact_profile_dashboard',
  'contacts_segments_dashboard',
  'contacts_labels_dashboard',
];

const contacts = accountId => ({
  parentNav: 'contacts',
  routes: [
    'contacts_dashboard',
    'contact_import_spreadsheet',
    'contact_wallet',
    'contact_profile_dashboard',
    'contacts_segments_dashboard',
    'contacts_labels_dashboard',
  ],
  menuItems: [
    {
      icon: 'book-contacts',
      label: 'ALL_CONTACTS',
      key: 'all_contacts',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
      isActive: route => ALL_CONTACTS_ROUTES.includes(route.name),
    },
    {
      icon: 'person-add',
      label: 'IMPORT_CONTACTS',
      key: 'import_contacts',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/import`),
      toStateName: 'contact_import_spreadsheet',
      isActive: route => route.name === 'contact_import_spreadsheet',
    },
    {
      icon: 'wallet-outline',
      label: 'CONTACT_WALLET',
      key: 'contact_wallet',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/wallet`),
      toStateName: 'contact_wallet',
      isActive: route => route.name === 'contact_wallet',
    },
    {
      icon: 'arrow-sort-down-lines',
      label: 'CONTACT_ATTRIBUTES',
      key: 'contact_attributes',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/attributes`),
      toStateName: 'attributes_dashboard',
    },
    {
      icon: 'building-bank',
      label: 'CONTACT_LABELS',
      key: 'contact_labels',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/labels`),
      toStateName: 'labels_dashboard',
    },
  ],
});

export default contacts;
